import { twMerge } from "tailwind-merge";

function cn(...classes: Array<string | false | null | undefined>) {
  return twMerge(...classes.filter((value): value is string => typeof value === "string"));
}

export { cn };
